/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoeffect3Inputs */

const en_aiflowphotoeffect3 = /** @type {(inputs: Aiflowphotoeffect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readability`)
};

const de_aiflowphotoeffect3 = /** @type {(inputs: Aiflowphotoeffect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesbarkeit`)
};

/**
* | output |
* | --- |
* | "Readability" |
*
* @param {Aiflowphotoeffect3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoeffect3 = /** @type {((inputs?: Aiflowphotoeffect3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoeffect3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoeffect3(inputs)
	return de_aiflowphotoeffect3(inputs)
});
export { aiflowphotoeffect3 as "aiFlowPhotoEffect" }